import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { API } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const match = (window.location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          credentials: "include",
          headers: { "X-Session-ID": sessionId },
        });
        window.history.replaceState(null, "", window.location.pathname);
        if (!res.ok) {
          const d = await res.json().catch(() => ({}));
          navigate("/login", { replace: true, state: { error: d.detail || "Sign-in failed" } });
          return;
        }
        const u = await res.json();
        setUser(u);
        navigate("/admin", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true, state: { error: "Sign-in failed" } });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="animate-spin text-[#D4AF37] mx-auto mb-4" size={32} />
        <p className="text-[#A3A3A3]">Signing you in…</p>
      </div>
    </div>
  );
}
